import netsAddressNotify from './nets-address-notify';
import moduleConfig from './module-config';

export default angular
  .module('app.address-notify', [])
  .config(['$stateProvider', moduleConfig])
  .component('netsAddressNotify', netsAddressNotify);
